import React from 'react';
import CustomerMyBusinessByCustomerList from './CustomerMyBusinessByCustomerList';
import { CRM_COMM_PAGE_ALL_ACQUISITION_BY_CUSTOMER_DETAIL_ACQUISITIONS } from '../../utils/crmCommunicationTableColumns';

export const CRM_ALL_ACQUISITION_MASK_BY_CUSTOMER = 'cust034';
export const CRM_ALL_ACQUISITION_MASK_DETAIL = 'cust035';

/** Všetky akvizície → Podľa zákazníka (cust034). */
export default function CustomerAllAcquisitionByCustomerList(props) {
  return (
    <CustomerMyBusinessByCustomerList
      {...props}
      adminMode
      mode="acquisitions"
      pageListKey="CustomerAllAcquisitionByCustomerList"
      pageAddKey="CustomerAllAcquisitionByCustomerDetail"
      maskAdd={CRM_ALL_ACQUISITION_MASK_DETAIL}
      endpointBase="/api/customer_evaluations/all_acquisitions/by_customer"
      embeddedListPageKey={CRM_COMM_PAGE_ALL_ACQUISITION_BY_CUSTOMER_DETAIL_ACQUISITIONS}
      adminDetailEndpointPrefix="/api/customer_evaluations/my_customers"
    />
  );
}
